import React from 'react';
import { connect } from 'react-redux';

import { Select } from 'redpoints-front-components/index';

import { allIncidentsFiltersSetProtectionType } from '../../../actions/allIncidentsActions';
import {
  getAllIncidentsFiltersProtectionTypeSelected,
  getAllIncidentsProtectionTypesResponse,
} from '../../../reducers/reporting/allIncidents';
import { translate } from '../../../helpers/languageHelper';

const AllIncidentsFiltersProtectionType = ({
  allIncidentsFiltersSetProtectionType,
  protectionTypeResponse,
  protectionTypeSelected,
}) => {
  const handlerSetProtectionType = protectionType =>
    allIncidentsFiltersSetProtectionType({ protectionType });

  return (
    <Select
      allowClear={true}
      data={protectionTypeResponse}
      label={translate('reporting.allIncidentsInternal.filters.protectionType')}
      mapping={{ key: 'key', value: 'value' }}
      onChange={handlerSetProtectionType}
      placeholder={translate('common.all')}
      value={protectionTypeSelected || undefined}
      showSearch
    />
  );
};

const mapStateToProps = state => {
  return {
    protectionTypeResponse: getAllIncidentsProtectionTypesResponse(state),
    protectionTypeSelected: getAllIncidentsFiltersProtectionTypeSelected(state),
  };
};

export default connect(mapStateToProps, {
  allIncidentsFiltersSetProtectionType,
})(AllIncidentsFiltersProtectionType);
